<div class="flex flex-col px-6 py-7">
  <div
    class="flex items-center justify-between mb-6"
  >
    <p class="text-2xl font-bold text-sigecom-dark-gray">
      {{
        isKeyManagement
          ? "Gerenciamento de chaves e sorteio"
          : isRoundManagement
            ? "Gerenciar rodadas e confrontos"
            : "Parametrização da fase"
      }}
    </p>
    <div class="flex items-center gap-2">
      <sigecom-button
        [title]="!(isMobile$ | async) ? 'Limpar filtros' : ''"
        type="danger"
        icon="trash-alt"
        (buttonClicked)="clearFilters()"
        *ngIf="hasFilters"
        class="w-fit"
      />
      <ng-container *ngTemplateOutlet="filters"></ng-container>
      <sigecom-button
        *ngIf="!isKeyManagement && !isRoundManagement"
        [title]="!(isMobile$ | async) ? 'CADASTRAR FASE' : ''"
        icon="clipboard"
        (buttonClicked)="navigateToCreate()"
        class="w-fit"
      />
    </div>
  </div>
  <div class="flex md:flex-row flex-col-reverse items-baseline gap-4">
    <sigecom-total-records-list
      [totalRecords]="pagedSimpleStepParametrization?.totalElements"
      [label]="'Etapas'"
    />
    <sigecom-filters-indicator
      [hasFilters]="hasFilters"
    ></sigecom-filters-indicator>
  </div>
  <ng-container
    *ngIf="
      pagedSimpleStepParametrization &&
        pagedSimpleStepParametrization.content?.length;
      else empty
    "
  >
    <sigecom-list-container>
      <sigecom-new-list-item
        *ngFor="let item of pagedSimpleStepParametrization.content"
        [title]="item.petTxNome!.toUpperCase()"
        (externalEdit)="openEditInNewTab(item)"
      >
        <div content class="flex items-center justify-between">
          <div class="flex flex-col gap-2 min-w-0">
            <div class="flex" [ngClass]="{ 'flex-col': (isMobile$ | async) }">
              <sigecom-list-info
                info="Formato da etapa"
                [value]="formatEnumLabel(item.petTxTipo!)"
              />

              <sigecom-list-divider *ngIf="!(isMobile$ | async)" />
              <sigecom-list-info
                *ngIf="isKeyManagement"
                info="Evento"
                [value]="formatEnumLabel(item.eveTxNome!)"
              />

              <sigecom-list-divider *ngIf="isKeyManagement && !(isMobile$ | async)" />
              <sigecom-list-info
                info="Categoria"
                [value]="
                  item.catTxNome?.charAt(0)!.toUpperCase() +
                  item.catTxNome?.slice(1)!.toLowerCase()
                "
              />
            </div>
          </div>
        </div>
        <div actions class="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:w-auto sm:flex-shrink-0">
            <sigecom-menu-bar
              class="hidden sm:block"
              contentClass="flex items-center"
            >
              <sigecom-popover
                [popoverTemplate]="popoverTemplate"
                triggerLabel="Gerenciar"
                triggerTitle="Gerenciar"
                triggerIcon="sliders"
                panelClass="w-72"
                triggerClass="w-full sm:w-auto"
              />
            </sigecom-menu-bar>

            <sigecom-menu-bar
              class="sm:hidden"
              contentClass="flex items-center"
              enableModal
              modalMetadata="Selecione uma opção"
              [modalTemplate]="mobileOptionsTemplate"
              triggerLabel="Gerenciar"
              triggerTitle="Gerenciar"
              triggerIcon="sliders"
              triggerClass="w-full"
            />

            <sigecom-button
              title="Editar"
              icon="pen"
              type="info"
              outlined
              (buttonClicked)="navigateToEdit(item)"
              class="w-full sm:w-auto"
            />
        </div>

          <ng-template #popoverTemplate>
            <div class="divide-y divide-slate-300">
              <div
                class="hover:bg-zinc-200 w-full cursor-pointer px-3 py-1 text-left"
                (click)="navigateToEditRoundWithLocal(item)"
              >
                <sigecom-menu-bar-item
                  label="Rodadas com local"
                  icon="location-crosshairs"
                  color="sigecom-info"
                  title="Rodadas com local"
                />
              </div>
              <div
                class="hover:bg-zinc-200 w-full cursor-pointer px-3 py-1 text-left"
                (click)="navigateToEditKey(item)"
              >
                <sigecom-menu-bar-item
                  label="Chave e sorteio"
                  icon="sitemap"
                  color="sigecom-info"
                  title="Chave e sorteio"
                />
              </div>
              <div
                class="hover:bg-zinc-200 w-full cursor-pointer px-3 py-1 text-left"
                (click)="navigateToEditRound(item)"
              >
                <sigecom-menu-bar-item
                  label="Rodada e confronto"
                  icon="flag"
                  color="sigecom-info"
                  title="Rodada e confronto"
                />
              </div>
              <div
                class="hover:bg-red-200 w-full cursor-pointer px-3 py-1 text-left"
                (click)="deleteStepParametrization(item)"
              >
                <sigecom-menu-bar-item
                  label="Excluir"
                  title="Excluir"
                  icon="trash"
                  color="sigecom-danger"
                />
              </div>
            </div>
          </ng-template>

          <ng-template #mobileOptionsTemplate>
            <div class="flex flex-col gap-3">
              <button
                type="button"
                class="flex items-center justify-between w-full rounded-xl bg-slate-100 hover:bg-slate-200 transition-colors px-4 py-3"
                (click)="navigateToEditRoundWithLocal(item)"
              >
                <span class="flex items-center gap-3">
                  <span
                    class="flex items-center justify-center w-8 h-6 text-sigecom-info"
                  >
                    <fa-icon icon="location-crosshairs"></fa-icon>
                  </span>
                  <span class="font-semibold text-sigecom-info"
                    >Rodadas com local</span
                  >
                </span>
                <fa-icon
                  icon="chevron-right"
                  class="text-sigecom-info"
                ></fa-icon>
              </button>

              <button
                type="button"
                class="flex items-center justify-between w-full rounded-xl bg-slate-100 hover:bg-slate-200 transition-colors px-4 py-3"
                (click)="navigateToEditKey(item)"
              >
                <span class="flex items-center gap-3">
                  <span
                    class="flex items-center justify-center w-8 h-6 text-sigecom-info"
                  >
                    <fa-icon icon="sitemap"></fa-icon>
                  </span>
                  <span class="font-semibold text-sigecom-info"
                    >Chave e desenho</span
                  >
                </span>
                <fa-icon
                  icon="chevron-right"
                  class="text-sigecom-info"
                ></fa-icon>
              </button>

              <button
                type="button"
                class="flex items-center justify-between w-full rounded-xl bg-slate-100 hover:bg-slate-200 transition-colors px-4 py-3"
                (click)="navigateToEditRound(item)"
              >
                <span class="flex items-center gap-3">
                  <span
                    class="flex items-center justify-center w-8 h-6 text-sigecom-info"
                  >
                    <fa-icon icon="flag"></fa-icon>
                  </span>
                  <span class="font-semibold text-sigecom-info"
                    >Rodadas e confrontos</span
                  >
                </span>
                <fa-icon
                  icon="chevron-right"
                  class="text-sigecom-info ml-2"
                ></fa-icon>
              </button>

              <button
                type="button"
                class="flex items-center justify-between w-full rounded-xl bg-red-50 hover:bg-red-100 transition-colors px-4 py-3"
                (click)="deleteStepParametrization(item)"
              >
                <span class="flex items-center gap-3">
                  <span
                    class="flex items-center justify-center w-8 h-6 text-sigecom-danger"
                  >
                    <fa-icon icon="trash"></fa-icon>
                  </span>
                  <span class="font-semibold text-sigecom-danger">Excluir</span>
                </span>
                <fa-icon
                  icon="chevron-right"
                  class="text-sigecom-danger"
                ></fa-icon>
              </button>
            </div>
          </ng-template>
      </sigecom-new-list-item>
    </sigecom-list-container>

    <sigecom-pagination-list
      *ngIf="pagedSimpleStepParametrization.content?.length"
      class="mt-7"
      [totalPages]="pagedSimpleStepParametrization.totalPages!"
      [maxDisplayedPages]="maxDisplayedPages"
      (pageChange)="onPageChange($event)"
    />
  </ng-container>

  <ng-template #empty>
    <sigecom-not-found-message-list message="Nenhuma etapa encontrada" />
  </ng-template>
</div>

<ng-template #filters>
  <sigecom-offcanvas>
    <ng-template>
    <div class="flex flex-col gap-4">
      <sigecom-input-search
        [placeholder]="'Nome da etapa'"
        [search]="filters$.get().petTxNome || ''"
        (searchChange)="filterByName($event)"
      />

      <sigecom-new-dropdown
        label="Formato da etapa"
        [options]="stepTypes"
        [optionLabel]="'label'"
        [optionIdentify]="'value'"
        (changeOption)="filterByStepType($event)"
        placeholder="Selecione o formato da etapa"
        [lastValidSelectedOption]="selectedStepType"
      />

      <sigecom-new-dropdown
        *ngIf="events"
        label="Evento"
        [options]="events.content || []"
        [optionLabel]="'eveTxNome'"
        [optionIdentify]="'eveNrId'"
        (changeOption)="onEventChange($event)"
        placeholder="Selecione o evento"
        [lastValidSelectedOption]="selectedEvent"
        searchble
        paged
        [totalPages]="events.totalPages || 1"
        [currentPage]="events.number || 0"
        (searchChange)="onEventSearch($event)"
        (pageChange)="onEventPageChange($event)"
      />

      <sigecom-new-dropdown
        [disabled]="!selectedEvent.eveNrId"
        label="Bloco de competição"
        [options]="competitionBlocks?.content || []"
        [optionLabel]="'bloTxNome'"
        [optionIdentify]="'bloNrId'"
        (changeOption)="onBlockChange($event)"
        placeholder="Selecione o bloco"
        [lastValidSelectedOption]="selectedBlock"
      />

      <sigecom-new-dropdown
        [disabled]="!selectedBlock.bloNrId"
        label="Competição"
        [options]="competitions?.content || []"
        [optionLabel]="'comTxNome'"
        [optionIdentify]="'comNrId'"
        (changeOption)="onCompetitionChange($event)"
        placeholder="Selecione a competição"
        [lastValidSelectedOption]="selectedCompetition"
        searchble
        paged
        [totalPages]="competitions?.totalPages || 1"
        [currentPage]="competitions?.number || 0"
        (searchChange)="onCompetitionSearch($event)"
        (pageChange)="onCompetitionPageChange($event)"
      />

      <sigecom-new-dropdown
        [disabled]="!selectedCompetition.comNrId"
        label="Categoria"
        [options]="categories?.content || []"
        [optionLabel]="'catTxNome'"
        [optionIdentify]="'catNrId'"
        (changeOption)="filterByCategory($event)"
        placeholder="Selecione a categoria"
        [lastValidSelectedOption]="selectedCategory"
        searchble
        paged
        [totalPages]="categories?.totalPages || 1"
        [currentPage]="categories?.number || 0"
        (searchChange)="onCategorySearch($event)"
        (pageChange)="onCategoryPageChange($event)"
      />
      <div class="flex items-end justify-end" *ngIf="hasFilters">
        <sigecom-button
          title="Limpar filtros"
          type="danger"
          icon="trash-alt"
          (buttonClicked)="clearFilters()"
        />
      </div>
    </div>
   </ng-template>
  </sigecom-offcanvas>
</ng-template>
